export const SRI_AUTHORIZED_ID = 101